








import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class InputBookingSport extends Vue {
  @Prop()
  placeholder!: string;
  public label = 'Ciudad';
  public error = '';
  public icon = 'location_city'
  public sports =  [
      'Practica Libre ',
      'Acondicionamiento Fisico',
'Adulto mayor',
'Aerobicos',
'Ajedrez',
'Atletismo',
'Baloncesto',
'Billar',
'BMX',
'Bocha',
'Ciclismo',
'Discapacidad',
'Futbol',
'Futbol de salon',
'Gimnasia',
'Judo',
'Karate Do',
'Lucha Olimpica',
'Patinaje artistico',
'Patinaje de carreras',
'Porras',
'Rugby',
'Skate',
'Taekwondo',
'Tenis de campo',
'Tenis de mesa',
'Tiro con Arco',
'Voleybol'
];
  public selectedSport = '';

  private mounted(){
    this.selectedSport = this.placeholder;
  }

  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'Deporte invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
